const reportsRoutesList={
    insuranceWiseOutStandingReport:"insurance-wise-outstanding-report",
    dailyRevenueReport:"daily-revenue-report",
    patientListReport:"patient-list-report",
    appointmentReport:"appointment-list-report",
    encounterListReport:"encounter-list-report",
    codificationReport:"codification-status-report",
    billwisereport:"bill-wise-report",
    patientWiseReport:"patient-wise-report",
    agingReportOld:"aging-report-old",
    agingReport:"aging-report",
    dailyInvoiceReport:"daily-invoice-report",
    monthlyInvoiceReport:"monthly-invoice-report",
    payemntTypeWiseReport:"payment-type-wise-report",
    departmentWiseReport:"department-wise-report",
    userwiseReport:"user-wise-report",
    doctotWiseBillingReport:"doctor-wise-billing-report",
    encounterWiseCollectionReport:"encounter-wise-collection-report",
    cptGroupWiseReport:"cpt-group-wise-reoprt",
    expenseReport:"expense-report",
    insuranceClaimSummaryReport:"insurance-claim-summary-report",
    insuranceWiseClaimReport:"insurance-wise-claim-report",
    insuranceClaimDetailsReport:"insurance-claim-details-report",
    reconcilationReport:"reconcilation-report",
}
export default reportsRoutesList